const StatusListaEnum = require('./StatusListaEnum');
const StatusExecucaoEnum = require('./StatusExecucaoEnum');
const StatusListaAPIEnum = require('./StatusListaAPIEnum');
const MovimentacaoListaEnum = require('./MovimentacaoListaEnum');
const TipoListaEnum = require('./TipoListaEnum');
const UploadeProgressEnum = require('./UploadeProgressEnum');
const PerfilEnum = require('./PerfilEnum');
const PermissaoContratanteEnum = require('./PermissaoContratanteEnum');
const TipoTelefoneEnum = require('./TipoTelefoneEnum');
const TipoStatusEnum = require('./TipoStatusEnum');
const TipoPerfilUsuarioEnum = require('./TipoPerfilUsuarioEnum');
const TipoConsultaParametrizacaoEnum = require('./TipoConsultaParametrizacaoEnum');
const TipoCardRoot = require('./TipoCardRoot');
const StatusListaRPAEnum = require('./StatusListaRPAEnum');
const TipoDocumentoEnum = require('./TipoDocumentoEnum');
const StatusEnvioListaEnum = require('./StatusEnvioListaEnum');
const TipoEventoWebhookEnum = require('./TipoEventoWebhookEnum');

module.exports = {
  StatusExecucaoEnum,
  StatusListaAPIEnum,
  StatusListaEnum,
  MovimentacaoListaEnum,
  TipoListaEnum,
  UploadeProgressEnum,
  PerfilEnum,
  PermissaoContratanteEnum,
  TipoTelefoneEnum,
  TipoStatusEnum,
  TipoPerfilUsuarioEnum,
  TipoConsultaParametrizacaoEnum,
  TipoCardRoot,
  StatusListaRPAEnum,
  TipoDocumentoEnum,
  StatusEnvioListaEnum,
  TipoEventoWebhookEnum,
};
